var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 10.1833C17.5003 5.60833 13.9503 2.5 10.0003 2.5C6.09199 2.5 2.50033 5.54167 2.50033 10.2333C2.00033 10.5167 1.66699 11.05 1.66699 11.6667V13.3333C1.66699 14.25 2.41699 15 3.33366 15H4.16699V9.91667C4.16699 6.69167 6.77533 4.08333 10.0003 4.08333C13.2253 4.08333 15.8337 6.69167 15.8337 9.91667V15.8333H9.16699V17.5H15.8337C16.7503 17.5 17.5003 16.75 17.5003 15.8333V14.8167C17.992 14.5583 18.3337 14.05 18.3337 13.45V11.5333C18.3337 10.95 17.992 10.4417 17.5003 10.1833Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 11.6667C7.96056 11.6667 8.33366 11.2936 8.33366 10.8333C8.33366 10.3731 7.96056 10 7.50033 10C7.04009 10 6.66699 10.3731 6.66699 10.8333C6.66699 11.2936 7.04009 11.6667 7.50033 11.6667Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 11.6667C12.9606 11.6667 13.3337 11.2936 13.3337 10.8333C13.3337 10.3731 12.9606 10 12.5003 10C12.0401 10 11.667 10.3731 11.667 10.8333C11.667 11.2936 12.0401 11.6667 12.5003 11.6667Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 9.19167C14.6003 6.81667 12.5337 5 10.042 5C7.51699 5 4.80033 7.09167 5.01699 10.375C7.07533 9.53333 8.62533 7.7 9.06699 5.46667C10.1587 7.65833 12.4003 9.16667 15.0003 9.19167Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.13cff3c9441876bf8d5c706bf950327e.svg";
export { ForwardRef as ReactComponent };